// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const pressHouse = defineModel({
  id: "press-house",
  batchId: "future",
  name: "Press house",
  tags: ["building","press","house","low-poly","age-of-mcp","future"],
  summary: "Houses beam presses for cider, oil and wine — one press, many pressings.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.55, 0.5, 1.15), color: "#8d8678", position: [0, 0.39, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6c665a", position: [-0.775, 0.39, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6c665a", position: [0.775, 0.39, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6c665a", position: [-0.775, 0.39, 0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6c665a", position: [0.775, 0.39, 0.575] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.8, 0.475, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.8, 0.475, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.8, 0.475, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.8, 0.475, 0.8] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.55, 0.95, 1.15), color: "#8d8678", position: [0, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [-0.775, 0.615, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [0.775, 0.615, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [-0.775, 0.615, 0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [0.775, 0.615, 0.575] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [-0.8, 0.725, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [0.8, 0.725, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [-0.8, 0.725, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [0.8, 0.725, 0.8] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.9, 0.14, 1.9), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.55, 0.95, 1.15), color: "#8d8678", position: [0, 0.615, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [-0.775, 0.615, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [0.775, 0.615, -0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [-0.775, 0.615, 0.575] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#6c665a", position: [0.775, 0.615, 0.575] },
      { geometry: new THREE.BoxGeometry(1.77, 0.07, 0.832544), color: "#7a4a36", position: [0, 1.31, 0.3175], rotation: [0.605954, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.77, 0.07, 0.832544), color: "#7a4a36", position: [0, 1.31, -0.3175], rotation: [-0.605954, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.79, 0.085, 0.085), color: "#5a3526", position: [0, 1.53, 0] },
      { geometry: new THREE.BoxGeometry(0.6, 0.5, 0.06), color: "#3a2f22", position: [-0.32, 0.41, 0.58] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.3, 0.06, 10, 1, false, 0, 3.141593), color: "#3a2f22", position: [-0.32, 0.66, 0.58], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.16, 0.18, 0.22, 10), color: "#5f3f20", position: [-0.32, 0.27, 0.515] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.4, 8), color: "#3c4146", position: [-0.32, 0.54, 0.515] },
      { geometry: new THREE.BoxGeometry(0.5, 0.06, 0.06), color: "#8a5f33", position: [-0.32, 0.72, 0.515] },
      { geometry: new THREE.CylinderGeometry(0.1376, 0.1376, 0.3, 9), color: "#8a5f33", position: [0.6, 0.29, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.1376, 0.1376, 0.3, 9), color: "#7a5430", position: [0.78, 0.29, 0.4] },
      { geometry: new THREE.CylinderGeometry(0.129, 0.129, 0.28, 9), color: "#8a5f33", position: [0.66, 0.58, 0.46] },
    ] },
  ],
  animations: [],
});
